
import React from 'react';
import { useLocation } from 'react-router-dom';
import { useUser } from '../context/UserContext';


const VideoCloseForm: React.FC = () => {

    const location = useLocation();
    const { name, mobile, whatsapp, language, email } = location.state || {};

    return (
        <div className="div-container">
            Video link has been sent to your Mobile Number {mobile}. 
        </div>
    );
};

export default VideoCloseForm;